<div class="announcement-component" v-if="dataExists"><p>{{ message }}</p></div>